import React, { forwardRef } from 'react'
import extraStyles from './Input.module.css'

const theme = {
  div: null,
  label: 'label block mb-2',
  input: 'input',
  error: 'text-sm text-red-400 mt-1',
  hint: 'text-sm text-yellow-700 mt-1',
}

export default forwardRef(function Input(props, ref) {
  const {
    type,
    value,
    className,
    classNames,
    onChange,
    divClassName,
    divProps,
    label,
    labelProps,
    error,
    errorProps,
    hint,
    icon,
    iconPosition = 'right',
    iconClassName,
    ...inputProps
  } = props

  const styles = { ...theme, ...classNames }

  return (
    <div
      className={[styles.div, divClassName]} {...divProps}>
      {label && (
        <label className={styles.label} {...labelProps}>
          {label}
        </label>
      )}
      <div
        className={[
          'relative',
        ]}
      >
        {icon && (
          <div className={extraStyles.iconSpacer} />
        )}
        {icon && iconPosition === 'left' && (
          <div
            children={icon}
            className={[
              extraStyles.icon,
              extraStyles.iconLeft,
              iconClassName,
            ]}
          />
        )}
        <input
          ref={ref}
          {...inputProps}
          className={[
            styles.input,
            extraStyles.input,
            className,
          ]}
          type={type}
          value={onChange ? (value === null || value === undefined ? '' : value) : value}
          onWheel={type === 'number' ? (e) => { 
            // For numeric inputs, disable scroll-wheel editing 
            // https://linear.app/roaming-hunger/issue/ENG-2234/rh-markup-with-random-percentages
            e.target.blur()
          } : null}
          onChange={event => {
            let val = event.target.value || null

            if (val !== null && type === 'number') {
              val = Number(val)
            }

            if (onChange) {
              onChange(val, event)
            }
          }}
        />
        {icon && iconPosition === 'right' && (
          <div
            children={icon}
            className={[
              extraStyles.icon,
              extraStyles.iconRight,
              iconClassName,
            ]}
          />
        )}
      </div>
      {error && (
        <div data-error className={styles.error}>
          {error}
        </div>
      )}
      {hint && (
        <div className={styles.hint}>
          {hint}
        </div>
      )}
    </div>
  )
})
